module.exports = __webpack_public_path__ + "static/media/Document1.42f44284.png";